import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/webapp`,
});

export const checkUsername = async (data) => {
  try {
    const response = await api.post('/validate-username', data);
    return response;
  } catch (error) {
    console.error('WebApp API Response Error:', error.response?.status, error.response?.data);
    throw error;
  }
};

export const webappLogin = async (data) => {
  return await api.post('/login', data);
};

export const webappJoin = async (data) => {
  return await api.post('/join', data);
};